export enum PaymentStatus {
  COMPLETED = "COMPLETED",
  PENDING = "PENDING",
  CANCELED = "CANCELED",
  EXPIRED = "EXPIRED",
}

export const paymentStatusDisplayNames = {
  [PaymentStatus.COMPLETED]: "결제 완료",
  [PaymentStatus.PENDING]: "결제 대기",
  [PaymentStatus.CANCELED]: "결제 취소",
  [PaymentStatus.EXPIRED]: "기한 만료",
};
